import VSLRow from "./VSLRow";

export default class VSLSectionRow extends VSLRow {

    constructor(id, text = null) {
        super(id, "section");

        this.text = text;
    }
}